import { render, staticRenderFns } from "./Narasumber.vue?vue&type=template&id=6ee8609f&scoped=true&"
import script from "./Narasumber.vue?vue&type=script&lang=js&"
export * from "./Narasumber.vue?vue&type=script&lang=js&"
import style0 from "./Narasumber.vue?vue&type=style&index=0&id=6ee8609f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee8609f",
  null
  
)

export default component.exports